import store from 'utils/store/withMiddleware'
import makeBase from 'core/services/email/sendEmailFromAgent/makeBase'
import produce from 'immer'
import { getPayloadForPlanTemplate } from 'FI/consumer/quotes/utils/contentV2'
import { QUOTES } from 'sites/routes'
import getURLProfile from 'utils/pivot/member/getURLProfile'

const TEMPLATE_NAME = 'fixed-indemnity-slaico-lmb-all-plans-june-2022'

const makeFBMPlansPayload = ({ valuesForm, agentInformation, salesCenterAgent }) => {
  const base = makeBase({ valuesForm, agentInformation, salesCenterAgent })

  const state = store.getState()

  const { plansFixed, selectedPlanId } = state

  const planPayloads = plansFixed.map(planId =>
    getPayloadForPlanTemplate(planId, state, undefined)
  )
  const profileUrl =
    getURLProfile({
      addPlanId: false,
      salesCenterAgent,
      agentId: agentInformation.agent_id,
      planId: undefined,
      placement: undefined
    }) + `&uid=${state.hcStorage.healthcareUserId}`

  return produce(base, baseDraft => {
    baseDraft.template_name = TEMPLATE_NAME

    baseDraft.message.global_merge_vars.push({
      name: 'planPayloads',
      content: planPayloads
    })
    baseDraft.message.global_merge_vars.push({
      name: 'extra',
      content: {
        host: `https://${window.location.hostname}`,
        quotesPath: QUOTES,
        generalSelectedPlanId: selectedPlanId,
        profileQueryString: profileUrl
      }
    })
  })
}

export default makeFBMPlansPayload
